import React from "react";
import { v4 as uuidv4 } from "uuid";

import Sidebar from "../shared/Sidebar";
import Landing from "./Landing";

import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import userActions from "../../flux/actions/UserActions";
import userListStore from "../../flux/stores/user/ListStore";

import { IUserViewData } from "../../models/user/UserViewData";
import { ISidebarDetail, SidebarDetail } from "../../models/shared/SidebarDetail";
import { UserFormData } from "../../models/user/UserFormData";
import * as CONSTANTS from "../../utilities/Constants";

import IActionHeaderFormData from "../../models/shared/ActionHeaderData";
import { IReportTemplateViewData, defaultReportTemplateData } from "../../models/reportTemplate/ReportTemplateViewData";

interface IIndexState {
  activeId: string;
  activeItem: IReportTemplateViewData;
  listData: ISidebarDetail[];
  isFullSidebarVisible: boolean;
}

export default class Report extends React.Component<{ location: any }, IIndexState> {
  private _mount = false;
  private _moduleName = CONSTANTS.MODULE_REPORT_TEMPLATE;
  private _isReload = true;
  private _id = "";

  constructor(props: { location: any }) {
    super(props);
    this._mount = false;


    if (this.props.location.state && this.props.location.state.isReloadFirst !== undefined) {
      this._isReload = this.props.location.state.isReloadFirst;
      this._id = this.props.location.state.id;
    }

    this.state = {
      activeId: "",
      activeItem: defaultReportTemplateData,
      listData: [],
      isFullSidebarVisible: true
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    const addRequest = {
        moduleName: CONSTANTS.MODULE_REPORT_TEMPLATE,
      } as IActionHeaderFormData;
      actionHeaderActions.common(addRequest).then();

  

    userActions.getAll().then();
    userListStore.on('change', (state) => {
     if (this._mount) {
      const data = state.userDataList as IUserViewData[];
      const items: ISidebarDetail[] = [];
        data.forEach(element => {
          items.push(new SidebarDetail(element.id, element.firstName));
        });
        
        this.setState({ listData: items });        
        if(this._isReload) {
          this.triggerGetById(items[0].id)
        } else {
          this.triggerGetById(this._id)
        }
      } 
    });

  }

  private triggerGetById(id: string) {
    userActions.getById(id).then();

    this.setState({ activeId: id });

    const data = {
      moduleName: this._moduleName,
      createData: new UserFormData(false, uuidv4(), CONSTANTS.DefaultGuid, false, "", "", "", {id:"", name:"", composite:false, clientRole:false, containerId:""}, "", ""),
      deleteId: id,
      deleteRequestId: uuidv4()
    } as IActionHeaderFormData;

    actionHeaderActions.common(data).then();
  }

  public onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  }

  public render() {
    return (
      <div className="row layout-row no-padding mt-4 ml-3">
        <div className="sidebar-layout">
          <Sidebar title={this._moduleName} onSelectLink={this.onSelectLink} listData={this.state.listData} activeId={this.state.activeId} />
        </div>
        <div className="main-layout">
          <Landing />
        </div>
      </div>
    );
  }
}
